import { useFragment } from "@apollo/client/react";

import { TenderState, TenderStateFragmentDoc } from "@/graphql/__generated__/graphql";

/**
 * Custom hook for fetching the current Tender's state using a fragment.
 *
 * This hook uses the `useFragment` hook from Apollo Client to automatically
 * subscribe to changes in the Tender state data.
 *
 * @param {number} currentTenderID - The tender ID to get state for
 * @returns {TenderState | null} Tender `state` of the current tender, or null if not found.
 */
export default function useTenderStateData(currentTenderID: number): TenderState | null {
  const { data } = useFragment({
    fragment: TenderStateFragmentDoc,
    from: {
      __typename: "Tender",
      id: currentTenderID,
    },
  });

  return data?.state ?? null;
}
